import { Reveal } from "./Reveal";
import { Droplets, Sprout, Wind, ShieldCheck } from "lucide-react";
import { SERVICES } from "../../data/content";

const ICONS = [Droplets, Sprout, Wind, ShieldCheck];

export const Services = () => (
  <section
    data-testid="services-section"
    className="bg-brand text-white/90"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
      <div className="max-w-2xl mb-16">
        <Reveal>
          <div className="eyebrow text-accent mb-5">Lo que incluye</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white">
            Más que una crema,
            <br />
            <span className="italic text-brand-soft">un cuidado completo</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={s.t} delay={i * 0.08}>
              <div
                data-testid={`service-card-${i}`}
                className="bg-brand h-full p-8 md:p-10 hover:bg-[#334335] transition-colors duration-500 group"
              >
                <Icon
                  size={28}
                  className="text-accent mb-8 group-hover:-translate-y-1 transition-transform duration-500"
                />
                <h3 className="font-serif text-2xl md:text-3xl text-white mb-3">
                  {s.t}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed">{s.d}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
